<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.dkzj">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Multi-Rolling Mill</span>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        dkzj: require("../../../assets/img/common/dkzj.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/dkzj.vue